module.exports = __webpack_public_path__ + "static/media/img02.72def913.webp";